module.exports = __webpack_public_path__ + "img/collectiongallery_hearts.cfb280c.jpg";